import React from 'react'
import { Stack, SimpleTabs } from '@/components/lib'
import useStore from '../../../store'
import useTitle from '../../../hooks/useTitle'

import Personnel from './Personnel'
import Roles from './Roles'

export default function Settings () {
  const { trial } = useStore()
  useTitle('Personnel', trial)

  return (
    <Stack>
      <SimpleTabs
        lazyMount
        tabs={[
          { title: 'Personnel', to: `/trials/${trial._id}/personnel/personnel`, content: <Personnel /> },
          { title: 'Roles', to: `/trials/${trial._id}/personnel/roles`, content: <Roles /> }
        ]}
      />
    </Stack>
  )
}
